<template>
     <div>
        <a-modal v-model="salaryVisit" title="项目金额调整" @ok="salaryOk" width="60%"  @cancel="closeSalaryVisit">
			<template slot="footer">
				<a-button key="submit" type="primary" @click="salaryOk"> 提交 </a-button>
				<a-button key="back" @click="closeSalaryVisit"> 取消 </a-button>
			</template>
            <a-form-model :model="affirmForm" ref="salaryForm" :rules="rules" :label-col="labelCol2"
				:wrapper-col="wrapperCol2">
				<!-- <a-row><span class="form_title2">项目信息:</span></a-row> -->
                <a-row>
                    <div style="margin: 10px 0;">
                        项目编号：
                        <a-input v-model="searchNumber" allowClear style="width: 300px;"></a-input>
                        <a-button key="submit" type="primary"  style="margin-left: 10px;" @click="search"> 查询 </a-button>
                    </div>
                </a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange v-if="salaryVisit" :data="ccC" @targetKeys="currencygetdata"  />
					</a-form-model-item>
				</a-row>
				<a-row><span class="form_title2">项目信息：</span></a-row>
                <a-row>
					<a-col :span="8">
						<a-form-model-item label="项目名称" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
							<a-input v-model="affirmForm.projectName" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="业务员" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="affirmForm.salesmen" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="项目类型" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"   >
							<a-input v-model="affirmForm.type" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
				<a-row>
                    <a-col :span="8">
						<a-form-model-item label="业务来源" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"   >
							<a-input v-model="affirmForm.businessSource" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="项目编号" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"   >
							<a-input v-model="affirmForm.identifier" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="隶属公司" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="affirmForm.companyOrder" allowClear  disabled></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
                <a-row>
                    <a-col :span="8">
						<a-form-model-item label="项目金额" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="newTotalMoney" :rules="{
							required: true,
							message: '请输入项目金额',
							trigger: 'change',
						}">
							<a-input v-model="affirmForm.totalMoney" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="业务宣传费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="affirmForm.commission" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="评审费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
							<a-input v-model="affirmForm.evaluationFee" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
                <a-row>
                    <a-col :span="8">
						<a-form-model-item label="服务费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="affirmForm.serviceCharge" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="分包费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="affirmForm.subprojectFee" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="虚拟税费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="affirmForm.virtualTax" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
                <a-row>
                    <a-col :span="8">
						<a-form-model-item label="其他费用" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="affirmForm.otherExpenses" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
			<a-form-model :model="salaryForm" ref="salaryForm" :rules="rules" :label-col="labelCol2"
				:wrapper-col="wrapperCol2">
				<a-row><span class="form_title2">金额修改：</span></a-row>
                <a-row>
                    <a-col :span="8">
						<a-form-model-item label="项目金额" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="newTotalMoney" :rules="{
							required: true,
							message: '请输入项目金额',
							trigger: 'change',
						}">
							<a-input v-model="salaryForm.newTotalMoney" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="业务宣传费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="salaryForm.newCommission" allowClear placeholder="请输入" ></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="评审费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
							<a-input v-model="salaryForm.newEvaluationFee" allowClear placeholder="请输入" ></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
                <a-row>
                    <a-col :span="8">
						<a-form-model-item label="服务费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="salaryForm.newServiceCharge" allowClear placeholder="请输入" ></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="分包费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="salaryForm.newSubprojectFee" allowClear placeholder="请输入" ></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="虚拟税费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="salaryForm.newVirtualTax" allowClear placeholder="请输入" ></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
                <a-row>
                    <a-col :span="8">
						<a-form-model-item label="其他支出" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="salaryForm.newOtherExpenses" allowClear placeholder="请输入" ></a-input>
						</a-form-model-item>
					</a-col>
                     <a-col :span="8">
						<a-form-model-item label="修改原因" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="remark" :rules="{
							required: true,
							message: '请输入修改原因',
							trigger: 'change',
						}">
							<a-textarea :auto-size="{ minRows: 2, maxRows: 10 }" v-model="salaryForm.remark" allowClear placeholder="请输入" ></a-textarea>
						</a-form-model-item>
					</a-col>
				</a-row>
                <a-row>
                    <a-col :span="8">
						<a-form-model-item label="附件(必填)" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadFileCode :data="uploadData" v-if="salaryVisit" @getList="getList"/>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
                        <a-form-model-item label="图片上传:" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadImgJava  v-if="salaryVisit" ref="uploadImgJava" :data="billDataImg" @getList="getList"/>
						</a-form-model-item>
                    </a-col>
                </a-row>
			</a-form-model>
		</a-modal>
        <!-- 查询项目弹窗 -->
         <!-- <a-modal v-model="affirmVisit" title="项目金额信息" @ok="affirmOk" width="60%">
			<template slot="footer">
				<a-button key="submit" type="primary" @click="affirmOk"> 确定 </a-button>
				<a-button key="back" @click="affirmVisit = false"> 取消 </a-button>
			</template>
			<a-form-model :model="affirmForm" ref="affirmForm" :rules="rules" :label-col="labelCol2"
				:wrapper-col="wrapperCol2">
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="项目编号" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"   :rules="{
							required: true,
							message: '请输入项目编号',
							trigger: 'change',
						}">
							<a-input v-model="affirmForm.identifier" allowClear disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="隶属公司" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  prop="companyOrder" :rules="{
							required: true,
							message: '请输入隶属公司',
							trigger: 'change',
						}">
							<a-input v-model="affirmForm.companyOrder" allowClear disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="项目金额" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="newTotalMoney" :rules="{
							required: true,
							message: '请输入项目金额',
							trigger: 'change',
						}">
							<a-input v-model="affirmForm.totalMoney" allowClear  disabled></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
                <a-row>
                    <a-col :span="8">
						<a-form-model-item label="业务费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="newCommission" :rules="{
							required: true,
							message: '请输入业务费',
							trigger: 'change',
						}">
							<a-input v-model="affirmForm.commission" allowClear disabled></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="评审费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="newEvaluationFee" :rules="{
							required: true,
							message: '请输入评审费',
							trigger: 'change',
						}">
							<a-input v-model="affirmForm.evaluationFee" allowClear  disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="服务费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="newServiceCharge" :rules="{
							required: true,
							message: '请输入服务费',
							trigger: 'change',
						}">
							<a-input v-model="affirmForm.serviceCharge" allowClear  disabled></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
                <a-row>
                    <a-col :span="8">
						<a-form-model-item label="分包费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="newSubprojectFee" :rules="{
							required: true,
							message: '请输入分包费',
							trigger: 'change',
						}">
							<a-input v-model="affirmForm.subprojectFee" allowClear disabled></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="虚拟税费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="newEvaluationFee" :rules="{
							required: true,
							message: '请输入虚拟税费',
							trigger: 'change',
						}">
							<a-input v-model="affirmForm.virtualTax" allowClear disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="其他支出" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="newOtherExpenses" :rules="{
							required: true,
							message: '请输入其他支出',
							trigger: 'change',
						}">
							<a-input v-model="affirmForm.otherExpenses" allowClear disabled></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal> -->

     </div>
</template>

<script>
import uploadImgJava from '@/components/module/uploadImgJava.vue'
import uploadFileCode from '@/components/module/uploadFileCode.vue'
import { projectAmountApply, salarySave,salaryCode } from '@/api/budget'
import ccChange from '@/components/module/ccChange'
export default {
    components: {
        ccChange,
        uploadFileCode,
        uploadImgJava
    },
    data(){
        return {
            billDataImg: {
                code: '',
                type: 'xmxg-certificate',
            },
            fileList:[],
            uploadData: {
				code: '',
				type: 'xmxg-appendix',
			},
            code: '',
            cc: '',
            ccC: '',
            searchNumber: '',
            affirmForm: {
                 // 项目金额
                totalMoney: '',
                // 业务宣传费 
                commission: '', 
                // 评审费 
                evaluationFee: '', 
                // 服务费 
                serviceCharge: '', 
                // 分包费 
                subprojectFee: '', 
                // 虚拟税费 
                virtualTax: '',  
                // 其他支出 
                otherExpenses: '',

            },
            affirmVisit: false,
            salaryVisit: false,
            salaryForm: {
                identifier: '',
                // 项目金额
                newTotalMoney: '',
                // 业务宣传费 
                newCommission: '', 
                // 评审费 
                newEvaluationFee: '', 
                // 服务费 
                newServiceCharge: '', 
                // 分包费 
                newSubprojectFee: '', 
                // 虚拟税费 
                newVirtualTax: '',  
                // 其他支出 
                newOtherExpenses: '',
                
            },
            labelCol2: {
				span: 3
			},
			wrapperCol2: {
				span: 21
			},
            imgList: [],

        }
    },
    methods: {
        getList(data) {
            if(data.type == 'file') {
              this.fileList = data
            }else {
                this.imgList = data
            }
        },
        init(){
            this.ccC = 'pr-amount'
            console.log('222222222222222222')
            // 获取项目申请编号
            salaryCode().then(res => {
                if(res.code == 200) {
                    this.code = res.data
                    this.uploadData.code = res.data
                    this.billDataImg.code = res.data
                    this.salaryVisit = true
                } else {
                    this.$message.error(res.msg)
                }
            })


        },
        // 获取抄送人
        currencygetdata(data) {
            console.log(data, 'data==============')
            if(data.length>0) {
			    this.cc = data.join(",")
            }
		},
        // 弹窗提交事件
        salaryOk() {
            // console.log(this.fileList, 'this.fileList======================')
        if(this.fileList.length<1 && this.imgList.length < 1) {
            this.$message.warning('修改项目金额请附上修改后合同！')
            return
        }
        this.$refs.salaryForm.validate((valid) => {
          if (valid) {
            this.$store.commit('LOADING', true)
            this.$store.commit('TIPS', '提交中......')
            salarySave({
                applyCode: this.code,
                cc: this.cc,
                projectName: this.salaryForm.projectName,
                salesmen: this.salaryForm.salesmen,
                type: this.salaryForm.type,
                businessSource: this.salaryForm.businessSource,
                companyOrder: this.salaryForm.companyOrder,
                identifier: this.salaryForm.identifier,
                newTotalMoney: this.salaryForm.newTotalMoney,
                // 业务宣传费 
                newCommission: this.salaryForm.newCommission, 
                // 评审费 
                newEvaluationFee: this.salaryForm.newEvaluationFee, 
                // 服务费 
                newServiceCharge: this.salaryForm.newServiceCharge, 
                // 分包费 
                newSubprojectFee: this.salaryForm.newSubprojectFee, 
                // 虚拟税费 
                newVirtualTax: this.salaryForm.newVirtualTax,  
                // 其他支出 
                newOtherExpenses: this.salaryForm.newOtherExpenses,
                // 项目金额
                totalMoney: this.affirmForm.totalMoney,
                // 业务宣传费 
                commission: this.affirmForm.commission, 
                // 评审费 
                evaluationFee: this.affirmForm.evaluationFee, 
                // 服务费 
                serviceCharge: this.affirmForm.serviceCharge, 
                // 分包费 
                subprojectFee: this.affirmForm.subprojectFee, 
                // 虚拟税费 
                virtualTax: this.affirmForm.virtualTax,  
                // 其他支出 
                otherExpenses: this.affirmForm.otherExpenses,
                remark: this.salaryForm.remark
            }).then(res=> {
                if(res.code == 200) {
                    this.$message.success(res.msg)
                } else {
                    this.$message.error(res.msg)

                }
                this.$store.commit('LOADING', false)
                this.$store.commit('TIPS', '加载中......')
                // 关闭弹窗
                this.salaryVisit = false
                // 刷新列表
                this.$emit('refreshList', false)
                //清空字段
                this.salaryForm = {
                        identifier: '',
                        companyOrder: '',
                        newTotalMoney: '',
                        newCommission: '', 
                        newEvaluationFee: '', 
                        newServiceCharge: '', 
                        newSubprojectFee: '', 
                        newVirtualTax: '',  
                        newOtherExpenses: '',
                        remark: ''
                        }
                this.searchNumber = ''
                this.cc = ''
            

            })
          }
        })
           

        },
        // 关闭弹窗
        closeSalaryVisit() {
            this.$refs.salaryForm.resetFields()
            this.salaryForm = {}
            this.salaryVisit = false
            this.searchNumber = ''
        },
        //查询项目信息
        search() {
            projectAmountApply({identifier: this.searchNumber}).then(res => {
                if(res.code == 200) {
                    // this.affirmVisit = true
                    this.affirmForm = res.data
                    this.affirmOk()
                }else {
                    this.$message.error(res.msg)
                }

            })

        },
        affirmOk() {
            var data  = JSON.parse(JSON.stringify(this.affirmForm))
            this.salaryForm = {
                projectName: data.projectName,
                salesmen: data.salesmen,
                type: data.type,
                businessSource: data.businessSource,
                identifier: data.identifier,
                companyOrder: data.companyOrder,
                // 项目金额
                newTotalMoney: data.totalMoney,
                // 业务宣传费 
                newCommission: data.commission, 
                // 评审费 
                newEvaluationFee: data.evaluationFee, 
                // 服务费 
                newServiceCharge: data.serviceCharge, 
                // 分包费 
                newSubprojectFee: data.subprojectFee, 
                // 虚拟税费 
                newVirtualTax: data.virtualTax,  
                // 其他支出 
                newOtherExpenses: data.otherExpenses,
                remark: '',
            }
            this.affirmVisit = false

        },
        // var data  = JSON.parse(JSON.stringify(this.affirmForm))
        //          this.salaryForm.identifier = data.identifier,
        //         // 项目金额
        //         this.salaryForm.newTotalMoney = data.totalMoney,
        //         // 业务宣传费 
        //         this.salaryForm.newCommission = data.commission, 
        //         // 评审费 
        //         this.salaryForm.newEvaluationFee = data.evaluationFee, 
        //         // 服务费 
        //         this.salaryForm.newServiceCharge = data.serviceCharge, 
        //         // 分包费 
        //         this.salaryForm.newSubprojectFee = data.subprojectFee, 
        //         // 虚拟税费 
        //         this.salaryForm.newVirtualTax = data.virtualTax,  
        //         // 其他支出 
        //         this.salaryForm.newOtherExpenses = data.otherExpenses,
        //     this.affirmVisit = false
        //     // this.$forceUpdate()

    },

}
</script>

<style lang="less" scoped>

</style>